import React from 'react';

import {
    AppBar,
    withStyles,
    Grid,
    Toolbar,
    Typography,
    Divider,
    ButtonBase
} from '@material-ui/core';
import { ListView } from 'antd-mobile';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import {
    withRouter,
} from "react-router-dom"
import './home.css'
import AppConfig from '../../control/config';

import Apis from '../../network/Apis';
import AppUtils from '../../control/apputlis';
import AppData from '../../model/AppData';
import { BorderTop } from '@material-ui/icons';
import ToName from '../../control/ToName';
const ICON_GIF = require("../../images/bg/ballLoad.gif");

const ICON_dianzan = require("../../images/icons/dianzan_icon@3x.png");
const ICON_dianzan_sel = require("../../images/icons/dianzan2_icon@3x.png");
const ICON_NoBg = require("../../images/bg/zanwupinglun@3x.png");


class CircleDel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isRequire: false,
            id: 0,
            pageNum: 1,
            data: null,
            commentList: [],
            value: '',
            isLoding: false,
            showComments:false
        };
        document.body.style.overflow = 'scroll';

    }

    componentDidMount() {
        let { id, os, token, customerId } = this.props.match.params;
        this.state.id = id;
        AppData.os = os
        if (token != 0) {
            AppData.me.token = token
        }
        
        AppData.me.customer_id = customerId
        this.getData()
        this.getCommentList()
        window.addEventListener('scroll', this.handleScroll, false)
        this.getServerConfig()
    }
    getServerConfig = async () => {
        let res = await Apis.encryptionServerConfig();
        if (res.code == 200 && res.data) {
            let showComments = res.data.ball_news_comment == '1' ? true : false
            this.setState({
                showComments: showComments,
            })
        }
        
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, false)
        this.setState = (state, callback) => {
            return;
        }
    }

    getScrollTop = () => {
        var scrollTop = 0, bodyScrollTop = 0, documentScrollTop = 0;
        if (document.body) {
            bodyScrollTop = document.body.scrollTop;
        }
        if (document.documentElement) {
            documentScrollTop = document.documentElement.scrollTop;
        }
        scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
        return scrollTop;
    }

    getScrollHeight = () => {
        var scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0;
        if (document.body) {
            bodyScrollHeight = document.body.scrollHeight;
        }
        if (document.documentElement) {
            documentScrollHeight = document.documentElement.scrollHeight;
        }
        scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
        return scrollHeight;
    }

    getWindowHeight = () => {
        var windowHeight = 0;
        if (document.compatMode == "CSS1Compat") {
            windowHeight = document.documentElement.clientHeight;
        } else {
            windowHeight = document.body.clientHeight;
        }
        return windowHeight;
    }

    // 页面滚动
    handleScroll = () => {
        if (this.getScrollHeight() - this.getScrollTop() - this.getWindowHeight() < 10) {
            // 解除绑定
            window.removeEventListener('scroll', this.handleScroll, false);
            // 在这里发送请求
            console.log('到底了')
            if (!this.state.isLoding) {
                this.state.isLoding = true;
                this.state.pageNum++;
                this.getCommentList()
            }

        }
    }



    getData = async () => {
        let customer_id = AppData.me.customer_id;
        let token = AppData.me.token;
        let channel = AppConfig.channelid;
        let result = await Apis.encryptionCircleDetail(customer_id, token, channel, this.state.id, 1);
        if (result.code == 200) {
            let _data = result.data;
            this.setState({ isRequire: true, data: _data });
            console.log(_data);

        }
    }

    getCommentList = async () => {
        let customer_id = AppData.me.customer_id;
        let token = AppData.me.token;
        let channel = AppConfig.channelid;
        this.state.isLoding = true;
        let result = await Apis.encryptionCircleCommentList(customer_id, token, channel, this.state.id, this.state.pageNum);
        if (result.code == 200) {
            let _data = result.data.list;
            console.log('commentList', _data);
            let list = this.state.commentList;
            // commentList
            for (let i = 0; i < _data.length; i++) {
                const element = _data[i];
                list.push(element)

            }
            // 并在请求到数据后重新开启监听
            setTimeout(() => window.addEventListener('scroll', this.handleScroll, false), 300)
            this.setState({ commentList: list, isLoding: false });

        }
    }



    back = () => {
        if (AppData.os == '' || AppData.os == '0') {
            window.history.back();
        }else{
            window.webkit.messageHandlers.VCBack.postMessage('');
        }
    }

    _handleChange = (value) => {
        this.setState({ value: value });
    }

    //点赞
    toZan = async (id, type, zanType) => {

        if (!AppData.me.isLogin()) {
            ToName(this.props,'/login')
            // this.props.history.push({ pathname: '/login' });
            return;
        }

        let customer_id = AppData.me.customer_id;
        let token = AppData.me.token;
        let channel = AppConfig.channelid;

        if (type == 1) {
            this.qcomment()
        } else {
            this.qcommentitem(id, zanType)
        }
        let result = await Apis.encryptionCircleZan(customer_id, token, channel, id, type, zanType);

    }
    //球圈点赞
    qcomment = () => {
        this.getData()
    }
    //评论点赞
    qcommentitem = (id, zanType) => {
        if (!AppData.me.isLogin()) {
            ToName(this.props,'/login')
            return;
        }
        let list = this.state.commentList;
        for (let i = 0; i < list.length; i++) {
            let item = list[i];
            if (item.comment_id == id) {
                item.is_zan = item.is_zan == 1 ? 0 : 1
                if (item.is_zan == 0) {
                    item.zan--;
                } else {
                    item.zan++;
                }
            }
        }
        this.setState({ commentList: list })
    }

    toCommentDel = (data) => {
        //去看评论详情
        this.props.history.push({ pathname: '/commentDel/', data: data });

    }

    _rendCommentItem = (data, index) => {
        //每一个评论
        return (
            <div key={index + 'cmment'} style={{ width: '100vm' }} >
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16, alignItems: 'flex-start' }}>
                    <div className='CircleCmmentItemAvatar' onClick={() => this.toCommentDel(data)}>
                        <img src={data.head} ></img>
                        <div className='CircleCmmentItemNameBox' >
                            <div className='name'>{data.name}</div>
                            <div className='time'>{data.time}</div>
                        </div>

                    </div>
                    <div className='CircleCmmentItemContentRight' onClick={() => this.toZan(data.comment_id, 2, data.is_zan == 0 ? 1 : 0)}>
                        <img src={data.is_zan == 0 ? ICON_dianzan : ICON_dianzan_sel} style={{ width: 14, height: 14 }}></img>
                        <div style={{ fontSize: 10, color: '#303030', marginLeft: 5 }}>{data.zan}</div>
                    </div>
                </div>
                <div className='CircleCmmentItemContentBox'>
                    <div className='CircleCmmentItemContentLeft' onClick={() => this.toCommentDel(data)}>
                        <div style={{ fontSize: 12, color: '#0D0D0D' }}>{data.content}</div>
                        {data.comment_num > 0 &&
                            <div style={{ position: 'relative', width: 200, height: 35 }}>
                                <div className='CircleCmmentItemContentLeftNum'>{data.comment_num + '条评论 >'}</div>
                            </div>
                        }
                    </div>
                    <div className='CircleCmmentItemContentRight' onClick={() => this.toZan(data.comment_id, 2, data.is_zan == 0 ? 1 : 0)}>
                        {/* <img src={data.is_zan == 0 ? ICON_dianzan : ICON_dianzan_sel} style={{ width: 14, height: 14 }}></img>
                        <div style={{ fontSize: 10, color: '#303030', marginLeft: 5 }}>{data.zan}</div> */}
                    </div>

                </div>
            </div>
        )
    }
    scrollToAnchor = (anchorName) => {
        if (anchorName) {
            //找到锚点
            let anchorElement = document.getElementById(anchorName);
            if (anchorElement) {
                anchorElement.scrollIntoView({
                    block: 'start',
                    behavior: 'smooth'
                })
            }
        }
    }

    _onClickMsg = async (comment_id) => {
        if (!AppData.me.isLogin()) {
            this.props.history.push({ pathname: '/login' });
            return;
        }
        const { value } = this.state;
        let customer_id = AppData.me.customer_id;
        let token = AppData.me.token;
        let channel = AppConfig.channelid;
        let result = await Apis.encryptionCircleToComment(customer_id, token, channel, this.state.id, comment_id, value);
        if (result.code == 200) {
            this.state.commentList = [];
            this.state.pageNum = 1;
            this.state.value = '';
            this.getCommentList()
        }
    }

    render() {
        const { classes } = this.props;
        let { isRequire, commentList, data, value } = this.state;
        let content = ''
        if (data && data.content.length > 0) {
            content = data.content;
        }


        return (
            <div >
                <AppBar position='fixed' className={classes.appbar} style={{ backgroundColor: '#fff', }}>
                    <Toolbar style={{ justifyContent: 'space-between', alignItems: 'center', width: '100%', paddingLeft: 0, paddingRight: 0 }}>
                        <div style={{ display: 'flex', marginLeft: 16, alignItems: 'center' }} onClick={() => this.back()}>
                            <ArrowBackIosIcon style={{ fontSize: '1.3rem', color: '#0D0D0D', marginRight: 5 }} />
                            <Typography className={classes.titleText}>球圈</Typography>
                        </div>
                        {isRequire && this.state.showComments &&
                            <a className='appBarHf' onClick={() => this.scrollToAnchor('activity1')}>{data.comment_num}条回复</a>

                        }

                        {/* {this.props.titlechildren} */}
                    </Toolbar>


                </AppBar>
                {isRequire &&
                    <Grid container style={{ width: '100vm', overflow: 'hidden' }}>
                        <div className='circleDelTopView'>
                            <div className='circleDelTopViewTitle'>
                                {data.title}
                            </div>
                            <div className='circleDelTopViewUser'>
                                <div className='circleDelTopViewUserLeft'>
                                    <img src={data.head} ></img>
                                    <span>{data.name}</span>
                                </div>
                                <span>{data.time}</span>
                            </div>

                            <div className='circleDelTopViewInfo'>{content}</div>

                            {data.img_list.map((item, i) => {
                                return <div key={i + 'img'}>
                                    <img className='circleDelTopViewImg' src={item}></img>
                                </div>
                            })}
                            {/* <Divider id="activity1" style={{ backgroundColor: '#F2F2F2', marginTop: 20, marginBottom: 20 }} /> */}

                        </div>


                        {this.state.showComments && <div id="activity1" style={{ width: '100%', marginLeft: 10, marginRight: 10, marginBottom: 70, marginTop: 30 }}>
                            <div className='circleDelCommentTitle' >全部评论</div>
                            {commentList.length > 0 && <div>
                                {commentList.map((item, i) => {
                                    return this._rendCommentItem(item, i)
                                })}
                            </div>}
                            {commentList.length == 0 &&
                                <div className='circleDelNoData'>
                                    <img src={ICON_NoBg}></img>
                                    <div style={{ color: '#939393', fontSize: 12 }}>暂无评论,说说你的看法</div>
                                </div>
                            }


                        </div>}

                        {this.state.showComments && <div className='circleInputbox' >

                            <Grid container direction='row' alignItems='center' justifycontent='space-between' className={classes.inputBack}>
                                <input value={value} onChange={(e) => this._handleChange(e.target.value)} className={classes.input} placeholder='说说你的看法...'></input>
                            </Grid>

                            {this.state.value == '' &&
                                <Grid container onClick={() => this.toZan(data.id, 1, data.is_zan == 0 ? 1 : 0)} style={{ marginRight: 10, display: 'flex', alignItems: 'center', maxWidth: 60, justifyContent: 'center' }}>
                                    <img style={{ width: 20, height: 20, marginRight: 5 }} src={data.is_zan == 0 ? ICON_dianzan : ICON_dianzan_sel}></img>
                                    <div style={{ color: '#303030', fontSize: 12 }}>{data.zan}</div>
                                </Grid>
                            }

                            {this.state.value != '' && <Grid container style={{ maxWidth: 70, marginRight: 10 }}>
                                <ButtonBase onClick={() => this._onClickMsg(0)} className={classes.sendMsg}>发送</ButtonBase>
                            </Grid>}
                        </div>}

                    </Grid>

                }
                {!isRequire && <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center' }}>
                    < img src={ICON_GIF} style={{ width: 280, height: 280, marginTop: 150, objectFit: 'scale-down' }}></img>
                    {/* <Typography style={{ fontSize: 12, color: '#878787', }} >赛事正在加载中...</Typography> */}
                </div>}


            </div>


        );
    }
}

export default withRouter(withStyles((theme) => ({
    input: {
        outline: 'none',
        border: 0,
        marginLeft: 16,
        backgroundColor: 'transparent',
        height: 30,
        flex: 1,
        fontSize: 12,
    },
    sendMsg: {
        background: '#007AFF',
        color: '#FFF',
        fontSize: 14,
        height: 30,
        width: 70,
        borderRadius: 17.5,
        // marginRight: 8,
        marginLeft: 8,
    },
    inputBack: {
        backgroundColor: '#EDEDED',
        borderRadius: 17.5,
        height: 30,
        // flex: 1,
        marginLeft: 8,
        // marginRight: 15,
        width: "75vw"
    },

    root: {
        padding: theme.spacing(0, 0, 0, 0),
        marginTop: 48,
    },
    titleText: {
        fontSize: 17,
        color: '#0D0D0D',
        fontWeight: 'bold',
    },
    appbar: {
        backgroundColor: '#FFF',
        flexDirection: 'rows',
        boxShadow: '1px 1px 3px #F0F0F0',
        marginTop: 0,
    },

}))(CircleDel));